import styled from 'styled-components';

export const Cloud = styled.div<{ src: string }>`
  max-width: 717px;
  width: 100%;
  height: 296px;
  background: ${({ src }) => `top / cover no-repeat url(${src})`};
`;
